var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWrite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.25 16.9688H1C0.585156 16.9688 0.25 17.3039 0.25 17.7188V18.5625C0.25 18.6656 0.334375 18.75 0.4375 18.75H18.8125C18.9156 18.75 19 18.6656 19 18.5625V17.7188C19 17.3039 18.6648 16.9688 18.25 16.9688ZM3.66484 15C3.71172 15 3.75859 14.9953 3.80547 14.9883L7.74766 14.2969C7.79453 14.2875 7.83906 14.2664 7.87188 14.2313L17.807 4.29609C17.8288 4.27441 17.846 4.24866 17.8578 4.2203C17.8695 4.19195 17.8756 4.16156 17.8756 4.13086C17.8756 4.10016 17.8695 4.06977 17.8578 4.04142C17.846 4.01306 17.8288 3.98731 17.807 3.96563L13.9117 0.0679688C13.8672 0.0234375 13.8086 0 13.7453 0C13.682 0 13.6234 0.0234375 13.5789 0.0679688L3.64375 10.0031C3.60859 10.0383 3.5875 10.0805 3.57812 10.1273L2.88672 14.0695C2.86392 14.1951 2.87207 14.3243 2.91045 14.446C2.94884 14.5677 3.01632 14.6782 3.10703 14.768C3.26172 14.918 3.45625 15 3.66484 15Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrite);
export default __webpack_public_path__ + "static/media/write.ed70e3a189475a9ee2affe231f69b4b5.svg";
export { ForwardRef as ReactComponent };